import axios from "axios"
import url from "../utils/url";

export const obtenerProductos = async () => {
    return await axios.get(`${url}/api/productos`);
}

